import moment from 'moment'
import maleSvg from '../../assets/images/male.svg'
export const CommentList = ({ data }) => {
    return (
        <>
            <li>
                <div className="d-flex align-items-start mb-1">
                    <div className="media">
                        <div className="starshot-ring mr-1">
                            <div className="avatar">
                                <div className="text-icon font-lato">{data.EMP_NAME[0]}</div>
                            </div>
                        </div>

                    </div>

                    <div className="profile-user-info">
                        <div className="d-flex align-items-center justify-content-between">
                            <p className="mb-0 font-lato font-12 font-weight-600">
                                {data.EMP_NAME}
                            </p>
                            <span className="align-right opacity-50 font-lato font-10 ml-1">
                                {moment(data.createdAt).fromNow()}
                            </span>
                        </div>
                        <p className="mb-0 card-text font-lato font-12">
                            {data.COMMENT}
                        </p>
                    </div>
                </div>
            </li>
        </>
    )
}